import React from 'react';
import Helmet from 'react-helmet';
import Header from '../components/header';
import Footer from '../components/footer';
import { useMenuState } from '~/utils/menu-state-provider';

const Layout = props => {
  const { menuState } = useMenuState();
  const {
    header_color,
    header_menu,
    mobile_menu,
    hides,
    global_meta_tags,
    inline_scripts,
  } = props;

  return (
    <>
      <Helmet
        title={props.site_title}
        meta={
          global_meta_tags
            ? global_meta_tags.map((tag, index) => {
                return {
                  name: tag.name,
                  content: tag.content,
                };
              })
            : []
        }
        style={[
          {
            cssText: `
              html {
                max-width: 100vw;
                min-height: 100%;
                overflow-x: hidden;
              }
              body {
                width: 100%;
                height: 100%;
              }
            `,
          },
        ]}
        htmlAttributes={{
          class: `${menuState ? 'menu-open' : ''}`,
          lang: 'en',
        }}
      />
      {/** Why is this site_name and other places site_title???! I don't know. */}
      <Header
        siteTitle={props.site_name}
        header_color={header_color}
        hides={hides}
        menu_src_override={props.menu_src_override}
        location={props.location}
        top_banner={props.top_banner}
        header_menu={header_menu}
        mobile_menu={mobile_menu}
      />
      <link
        rel='preconnect'
        href='https://fonts.bunny.net'
      />
      <link
        href='https://fonts.bunny.net/css2?family=Rubik:wght@300;400;500;600;700&display=swap'
        rel='stylesheet'
      />
      {props.children}
      <Footer hides={hides} />
    </>
  );
};

export const LayoutPadding = ({ children, cols_class = 'col-12' }) => (
  <div className='block'>
    <div className='container'>
      <div className='row'>
        <div className={cols_class}>{children}</div>
      </div>
    </div>
  </div>
);

export default Layout;
